module.exports = __webpack_public_path__ + "img/l4s.3b7f40f8.png";